import React, { Component } from 'react';
import MobileMenu from './MobileMenu';
import SearchBarWrapper from './SearchBarWrapper';

export class Patientayout extends Component {
    constructor(props) {
        super(props)
        this.state = {
            expanded: (this.props.container) ? false : true
        }
    }
    toggleMenu() {
        this.setState({ expanded: !this.state.expanded })
    }
    render() {
        return (
            <>
                {/* <div className="row header-bg text-center h-15">
                    <div className="col-2 logo-image"></div>
                    <div className="col-10  d-flex flex-column justify-content-center">
                        <div className="row">
                            <div className="col-12">
                                <h1> Person </h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <h2> Users Name </h2>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="row d-block d-md-flex flex-md-row" style={{ flexFlow: "column", minHeight: '100%', maxHeight: '100%' }}>

                    <div className="menu col-auto rounded-start d-none d-xl-flex flex-sm-column rounded-5 position-relative p-3 menu-bg text-center flex-shrink-1" >
                        {this.props.menu}
                    </div>
                    <div className="col-lg-12 rounded-top d-flex d-md-none rounded-5 position-relative p-0 menu-bg text-center"></div>
                    <div className="flex-grow-1 d-flex flex-column col-auto p-0 p-md-2 content-container">
                        {
                            this.props.nofilter
                                ?
                                <></>
                                :
                                <SearchBarWrapper
                                    key={'sbw_' + new Date()}
                                    options={['email']}
                                    showNotifications={true} 
                                    search={this.props.search} 
                                    breadcrums={this.props.breadcrums} 
                                    settings={true} />
                        }

                        {
                            (this.props.container)
                                ?
                                <>
                                    <div
                                        className="col-12 d-flex flex-column flex-grow-1">
                                        <div className={`content-area bg-content-area d-flex flex-column flex-grow-1 ${this.props.full ? '' : 'mt-0 mt-xl-3'} shadow shadow-2 rounded rounded-5 text-primary`}>
                                            {
                                                (this.props.title)
                                                    ?
                                                    <div className='head text-center'>
                                                        <h1>{this.props.title}</h1>
                                                        {this.props.description ? <p>{this.props.description}</p> : <></>}
                                                    </div>
                                                    :
                                                    <></>
                                            }
                                            {this.props.container}
                                        </div>
                                    </div>

                                </>
                                :
                                <></>
                        }
                        {/* <div className='fixed-bottom justify-content-evenly rounded-bottom d-flex d-md-none rounded-5 p-0 menu-bg text-center'> */}
                        <MobileMenu menu={this.props.menu} />
                    </div>

                </div>
            </>
        );
    }
}

